/* eslint-disable */
import React, { useEffect, useState } from "react";
import { translate } from "react-i18next";
import { Button, Grid, Icon, Input, Radio } from "semantic-ui-react";
import { connect } from "react-redux";
import { ALL_ALLOW_ROLES, UPL_CUSTOMER } from '../../utils/constant';

const TitleBarDelivery = (props) => {
  const [ImportModalState, setImportModalState] = useState(false);
  const [createPermissionModalState, setcreatePermissionImportModalState] = useState(false);
  const [Permissions, setPermissions] = useState(false);
  const [showFilterDiv, setshowFilterDiv] = useState(false)

  useEffect(() => {
    checkPermission()
  }, [Permissions])

  const handleImportClose = () => {
    setImportModalState(false);
    window.location.reload();
  };

  const handlepermissionModal = () => {
    setcreatePermissionImportModalState(true);
  }

  const handlepermissionModalClose = () => {
    setcreatePermissionImportModalState(false);
    // window.location.reload();
  };

  const handleImportOpen = () => {
    setImportModalState(true);
  };

  const showDeliveryModal = (e) => {
    props.addNewDeliveryModal(true)
  };

  const checkPermission = () => {
    switch (props.title) {
      case ('Fornecedor'):
        setPermissions(!props.permissions.TA_VENDOR_MASTER.CREATE)
        break;
      case ('Vendor'):
        setPermissions(!props.permissions.TA_VENDOR_MASTER.CREATE)
        break;
      case ('Vendor Share'):
        setPermissions(!props.permissions.TA_VENDOR_SHARE.CREATE)
        break;
      case ('Vendor Share'):
        setPermissions(!props.permissions.TA_VENDOR_SHARE.CREATE)
        break;
      case ('Vendor Group'):
        setPermissions(!props.permissions.TA_VENDOR_GROUP.CREATE)
        break;
      case ('Grupo de Fornecedores'):
        setPermissions(!props.permissions.TA_VENDOR_GROUP.CREATE)
        break;
      case ('Vehicle Type'):
        setPermissions(!props.permissions.TA_VEHICLE_TYPE_MASTER.CREATE)
        break;
      case ('Tipo de Veículo'):
        setPermissions(!props.permissions.TA_VEHICLE_TYPE_MASTER.CREATE)
        break;
      case ('Users'):
        setPermissions(!props.permissions.TA_USER_MASTER.CREATE)
        break;
      case ('Comercial'):
        setPermissions(!props.permissions.TA_USER_MASTER.CREATE)
        break;
      case ('Drivers'):
        setPermissions(!props.permissions.TA_DRIVER_MASTER.CREATE)
        break;
      case ('Motoristas'):
        setPermissions(!props.permissions.TA_DRIVER_MASTER.CREATE)
        break;
      case ('Consignor'):
        setPermissions(!props.permissions.TA_CONSIGNOR_MASTER.CREATE)
        break;
      case ('Expedidor'):
        setPermissions(!props.permissions.TA_CONSIGNOR_MASTER.CREATE)
        break;
      case ('Consignee'):
        setPermissions(!props.permissions.TA_CONSIGNEE_MASTER.CREATE)
        break;
      case ('Consignatário'):
        setPermissions(!props.permissions.TA_CONSIGNEE_MASTER.CREATE)
        break;
      case ('City'):
        setPermissions(!props.permissions.TA_CITY_MASTER.CREATE)
        break;
      case ('Cidade'):
        setPermissions(!props.permissions.TA_CITY_MASTER.CREATE)
        break;
      case ('Route'):
        setPermissions(!props.permissions.TA_CHECKPOINT_MASTER.CREATE)
        break;
      case ('Rota'):
        setPermissions(!props.permissions.TA_CHECKPOINT_MASTER.CREATE)
        break;
      case ('Product'):
        setPermissions(!props.permissions.TA_SKU_MASTER.CREATE)
        break;
      case ('Produtos'):
        setPermissions(!props.permissions.TA_SKU_MASTER.CREATE)
        break;
      case ('Users'):
        setPermissions(!props.permissions.TA_USER_ROLE.CREATE)
        break;
      case ('Papel do usuário'):
        setPermissions(!props.permissions.TA_USER_ROLE.CREATE)
        break;
      default:
        break;
    }
  }

  let handleFilter = () => {
    setshowFilterDiv(!showFilterDiv)
  }

  const [invoiceNo, setInvoiceNo] = useState("")
  const [invoiceRefNo, setInvoiceRefNo] = useState("")
  const [deliveryReferenceNo, setDeliveryReferenceNo] = useState("")
  const [lrNumber, setLrNumber] = useState("")


  const searchCall = () => {
    let searchElement = {
      delivery_reference_no: deliveryReferenceNo,
      invoice_no: invoiceNo,
      invoice_reference_no : invoiceRefNo,
      lr_no : lrNumber
    }
    props.handleMetaSearch(searchElement)
  }

  const { t } = props;
  return (
    <div id="dispatch_bar">
      <div className="container-fluid dip_bar">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between">
              <h2 className="page-title">{props.title}</h2>
              <div className="form-inline">
                {/* <span>{this.state.path}</span> */}
                {props.radioToggle && (
                  <Radio
                    toggle
                    className="mr-1"
                    name="gridView"
                    checked={props.toggle}
                    onChange={props.toggleView}
                  />
                )}

                {/* <Input size="mini" icon={{ name: 'search', circular: true }} onKeyUp={props.handleSearch} className="mr-1 ml-1" placeholder={t("search") || "Search"} /> */}

                {props?.addNewDelivery == true ?
                  <>
                    <button size="mini" style={{ border: 'none' }} className="grey-btn-new" onClick={showDeliveryModal} color="#f1f1f1" icon >
                      <i className="fas fa-plus"></i> New
                    </button>
                  </>
                  :
                  null
                }
                {!props.exportHidden ? <button
                  type="button"
                  data-toggle="modal"
                  data-target="#ExportXL"
                  // hidden={props.exportHidden}
                  onClick={props.exportDataGrid}
                  className="grey-btn"
                >
                  <i class="fas fa-file-export mr-1"></i>
                  {t("export") || "Export"}
                </button>
                  : null}

                {ALL_ALLOW_ROLES ? (
                  <button size="mini" className="grey-btn-01 btn-font" onClick={handleFilter} color="#f1f1f1" icon >
                    <Icon name="filter" size="small" />
                    Filter
                  </button>
                ) : (null)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showFilterDiv == true/*  && localStorage.getItem("role") == "Elixir" || localStorage.getItem("role") == "Administrator" */ ? (
        <>
          {/* <div id="dispatch_bar"> */}
          <div>
            <Grid style={{ margin: '0px', background: 'white', paddingLeft: '15px' }}>
              <Grid.Row>
                <Grid.Column width={3}>
                  <label>{t("delivery.delivery_ref_no")||"Delivery Reference No"}</label>
                  <Input type="text" placeholder=""
                    onChange={(e) => setDeliveryReferenceNo(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        searchCall()
                      }
                    }}
                  />
                </Grid.Column>
                <Grid.Column width={1}>
                </Grid.Column>
                <Grid.Column width={3}>
                  <label>{t("delivery.invoice_no")||"Invoice No"}</label>
                  <Input type="text" placeholder=""
                    onChange={(e) => setInvoiceNo(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        searchCall()
                      }
                    }}
                  />
                </Grid.Column>

                <Grid.Column width={1}>
                </Grid.Column>
                <Grid.Column width={3}>
                  <label>{t("delivery.invoice_ref_no")||"Invoice Reference Number"}</label>
                  <Input type="text" placeholder=""
                    onChange={(e) => setInvoiceRefNo(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        searchCall()
                      }
                    }}
                  />
                </Grid.Column>

                <Grid.Column width={1}/>
                <Grid.Column width={3}>
                  <label>{t("delivery.lr_no")||"LR Number"}</label>
                  <Input type="text" placeholder=""
                    onChange={(e) => setLrNumber(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        searchCall()
                      }
                    }}
                  />
                </Grid.Column>

              </Grid.Row>

              <Grid.Row centered>
                <Grid.Column width={2}>
                  <Button className="w3-button w3-small w3-border w3-blue w3-hover-blue ml-1 w3-round" onClick={searchCall}>Search</Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </>
      ) : null}
    </div>
  );
};
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
}
export default connect(mapStateToProps)(translate("title_bar")(TitleBarDelivery));
